/**
 * CPG garage dock (P1 chrome) — behavior for snippets/cpg-garage-dock.liquid.
 * The pill toggles the "My Garage" balloon; the balloon lists saved vehicles
 * (active highlighted, others switchable), and Add/Manage open the full YMM
 * picker modal. Reads state from the YMM widget (localStorage cpg:garage:list /
 * cpg:garage:vehicle + the cpg:vehicle-changed event). Desktop only.
 */
(function () {
  'use strict';
  var GUEST_SLOTS = 3;

  function readActive() {
    try { var r = localStorage.getItem('cpg:garage:vehicle'); var v = r ? JSON.parse(r) : null;
      return v && v.year && v.make && v.model ? v : null; } catch (e) { return null; }
  }
  function readList() {
    try { var r = localStorage.getItem('cpg:garage:list'); var l = r ? JSON.parse(r) : []; return Array.isArray(l) ? l : []; }
    catch (e) { return []; }
  }
  // Shown to the shopper: the full vehicle including the engine (owner 2026-10-02).
  function label(v) { return [v.year, v.make, v.model, v.submodel, v.engine].filter(Boolean).join(' '); }
  // Identity for the saved list stays year/make/model/trim, unchanged from before.
  function id(v) { return [v.year, v.make, v.model, v.submodel].filter(Boolean).join(' '); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(dock) {
    if (dock.__cpgDockInit) return; dock.__cpgDockInit = true;
    var pill = dock.querySelector('[data-cpg-dock-toggle]');
    var panel = dock.querySelector('[data-cpg-dock-panel]');
    var labelEl = dock.querySelector('[data-cpg-dock-label]');
    var slotsEl = dock.querySelector('[data-cpg-dock-slots]');
    var listEl = dock.querySelector('[data-cpg-dock-list]');

    function render() {
      var active = readActive();
      var list = readList();
      dock.classList.toggle('has-vehicle', !!active);
      labelEl.textContent = active ? label(active) : 'No vehicle yet';
      slotsEl.textContent = list.length + ' / ' + GUEST_SLOTS + ' slots';
      if (!list.length) {
        listEl.innerHTML = '<div class="cpg-dock__empty">No vehicles saved yet.</div>';
        return;
      }
      var activeId = active ? id(active) : null;
      listEl.innerHTML = list.map(function (v) {
        var isA = id(v) === activeId;
        return '<div class="cpg-dock__veh' + (isA ? ' is-active' : '') + '">' +
          '<span class="cpg-dock__veh-dot"></span>' +
          '<span class="cpg-dock__veh-name">' + esc(label(v)) + '</span>' +
          (isA ? '<span class="cpg-dock__veh-tag">Active</span>'
               : '<button type="button" class="cpg-dock__veh-switch" data-cpg-dock-switch="' + esc(id(v)) + '">Switch</button>') +
          '</div>';
      }).join('');
      listEl.querySelectorAll('[data-cpg-dock-switch]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var want = btn.getAttribute('data-cpg-dock-switch');
          var v = readList().filter(function (x) { return id(x) === want; })[0];
          if (v && window.CPGFitment && CPGFitment.saveVehicle) CPGFitment.saveVehicle(v);
        });
      });
    }

    function open() { panel.hidden = false; dock.classList.add('is-open'); pill.setAttribute('aria-expanded', 'true'); render(); }
    function close() { panel.hidden = true; dock.classList.remove('is-open'); pill.setAttribute('aria-expanded', 'false'); }

    pill.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      dock.classList.contains('is-open') ? close() : open();
    });
    // Add / Manage open the YMM modal (data-cpg-garage-button, handled by the widget) — just close the balloon after.
    dock.querySelectorAll('[data-cpg-garage-button]').forEach(function (b) {
      b.addEventListener('click', function () { close(); });
    });
    document.addEventListener('click', function (e) { if (!dock.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('cpg:vehicle-changed', render);
    window.addEventListener('pageshow', render);
    render();
  }

  function boot() { var d = document.querySelector('[data-cpg-dock]'); if (d) init(d); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
